module.exports = __webpack_public_path__ + "static/assets/2783daab364da7503ecb3c57054e7a9f.svg";